import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getSmoothStepPath, useInternalNode } from "@xyflow/react";
import { useHoverTargetId } from "./connectionDropStore";
/**
 * A react-flow `connectionLineComponent` that snaps its endpoint to the
 * hovered drop-target's handle when one is active. The hover state comes
 * from the shared connection-drop store, which `useEditorConnections` (or an
 * equivalent surface-level hook) updates while the user drags.
 */ export function SnapConnectionLine({ fromX, fromY, toX, toY, fromPosition, toPosition, fromHandle }) {
    const hoverTargetId = useHoverTargetId();
    const hoverNode = useInternalNode(hoverTargetId ?? "");
    const fromType = fromHandle.type;
    let endX = toX;
    let endY = toY;
    let endPosition = toPosition;
    if (hoverNode) {
        const wantType = fromType === "source" ? "target" : "source";
        const handle = hoverNode.internals.handleBounds?.[wantType]?.[0] ?? null;
        if (handle) {
            endX = hoverNode.internals.positionAbsolute.x + handle.x + handle.width / 2;
            endY = hoverNode.internals.positionAbsolute.y + handle.y + handle.height / 2;
            endPosition = handle.position;
        }
    }
    const [sourceX, sourceY, sourcePos, targetX, targetY, targetPos] = fromType === "source" ? [
        fromX,
        fromY,
        fromPosition,
        endX,
        endY,
        endPosition
    ] : [
        endX,
        endY,
        endPosition,
        fromX,
        fromY,
        fromPosition
    ];
    const [path] = getSmoothStepPath({
        sourceX,
        sourceY,
        sourcePosition: sourcePos,
        targetX,
        targetY,
        targetPosition: targetPos
    });
    return /*#__PURE__*/ _jsxs("g", {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: path,
                fill: "none",
                stroke: "#3B82F6",
                strokeWidth: 2
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: targetX,
                cy: targetY,
                r: 4,
                fill: "#3B82F6"
            })
        ]
    });
}

//# sourceMappingURL=SnapConnectionLine.js.map